import { Alert, Box, Button, Container, Paper } from '@mui/material';
import { Link as RouterLink, useRouteError, isRouteErrorResponse } from 'react-router-dom';

export function RouteError() {
  const err = useRouteError();

  let message: string;
  if (isRouteErrorResponse(err)) {
    message = `${err.status} ${err.statusText}`;
  } else if (err instanceof Error) {
    message = err.message;
  } else {
    message = 'Something went wrong.';
  }

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }} elevation={1}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {message}
        </Alert>
        <Box>
          <Button component={RouterLink} to="/" variant="contained">
            Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
